// src/components/PhotoActionButtons.js
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './PhotoActionButtons.css';

const PhotoActionButtons = ({ onPhotoSelected }) => {
  const { t } = useTranslation();
  const fileInputRef = useRef(null);

  const handleOpenCamera = () => {
    // Hint the browser to use the camera
    if (fileInputRef.current) {
      fileInputRef.current.setAttribute('capture', 'environment');
      fileInputRef.current.click();
    }
  };

  const handleOpenGallery = () => {
    // Remove capture attribute to open gallery instead of camera
    if (fileInputRef.current) {
      fileInputRef.current.removeAttribute('capture');
      fileInputRef.current.click();
    }
  };
  
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    
    if (onPhotoSelected) {
      onPhotoSelected(file);
    }
    
    // Reset file input
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };

  return (
    <>
      <div className="photo-action-buttons">
        <button 
          className="photo-action-button camera-button"
          onClick={handleOpenCamera}
        >
          <span className="button-icon">
            <svg width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M23.5 18C23.5 18.5304 23.2893 19.0391 22.9142 19.4142C22.5391 19.7893 22.0304 20 21.5 20H3.5C2.96957 20 2.46086 19.7893 2.08579 19.4142C1.71071 19.0391 1.5 18.5304 1.5 18V7C1.5 6.46957 1.71071 5.96086 2.08579 5.58579C2.46086 5.21071 2.96957 5 3.5 5H7.5L9.5 2H15.5L17.5 5H21.5C22.0304 5 22.5391 5.21071 22.9142 5.58579C23.2893 5.96086 23.5 6.46957 23.5 7V18Z" stroke="var(--Icon-Default-Default, #1E1E1E)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12.5 16C14.7091 16 16.5 14.2091 16.5 12C16.5 9.79086 14.7091 8 12.5 8C10.2909 8 8.5 9.79086 8.5 12C8.5 14.2091 10.2909 16 12.5 16Z" stroke="var(--Icon-Default-Default, #1E1E1E)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </span>
          <span className="button-text">{t('takePhoto')}</span>
        </button>
        <button
          className="photo-action-button gallery-button"
          onClick={handleOpenGallery}
        >
          <span className="button-icon">
            <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.44444 22H21.5556C22.9056 22 24 21.0051 24 19.7778V4.22222C24 2.99492 22.9056 2 21.5556 2H4.44444C3.09442 2 2 2.99492 2 4.22222V19.7778C2 21.0051 3.09442 22 4.44444 22ZM4.44444 22L17.8889 9.77778L24 15.3333M10.5556 8.11111C10.5556 9.03159 9.73475 9.77778 8.72222 9.77778C7.7097 9.77778 6.88889 9.03159 6.88889 8.11111C6.88889 7.19064 7.7097 6.44444 8.72222 6.44444C9.73475 6.44444 10.5556 7.19064 10.5556 8.11111Z" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </span>
          <span className="button-text">{t('chooseFromGallery')}</span>
        </button>
      </div>
      
      {/* Hidden file input for both camera and gallery selection */}
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
    </>
  );
};

export default PhotoActionButtons;